import React from 'react';
import Link from '@/components/Link';
import routes from '@gik/core/routes';
import bemBlock from '@gik/core/utils/bemBlock';
import Avatar from '@gik/ui/Avatar';
import Popover from '@gik/ui/Popover';
import { UserNav } from '..';
import { useUserStore } from '@gik/core/store/UserStore';
import { useUser } from '@gik/api/users/user';

export interface IUserAvatarMenuProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function UserAvatarMenu({
  className,
}: React.PropsWithChildren<IUserAvatarMenuProps>): React.ReactElement {
  const bem = bemBlock('user-avatar-menu');

  const [isOpen, setOpen] = React.useState(false);
  const userStore = useUserStore();
  const { data: user } = useUser(userStore.id);

  return (
    <Popover
      className={bem('popover', null, className)}
      trigger={
        <div className={bem('avatar-wrapper')}>
          <Link href={routes.userProfile}>
            <a>
              <Avatar loading={!user} imageUrl={user?.avatarThumbSmallURL} />
            </a>
          </Link>
        </div>
      }
      isOpen={isOpen}
      overlap
      onClose={() => setOpen(false)}
      onHover={() => {
        if (user) setOpen(true);
      }}
      hasArrowIndicator={false}
      placement="bottom-end"
      noPad
      hoverable
    >
      <UserNav />
    </Popover>
  );
}
